import { jsx as s } from "react/jsx-runtime";
import { d as i, w as f, x as m } from "../../../vendor-EQDp64ng.js";
import "react";
import { getSpacingClasses as n } from "../../../utils/getSpacingClasses/index.js";
import { s as a } from "../../../shared.module-BNaUp3Ey.js";
import '../../../assets/index22.css';const b = "_popover_3rdjd_1", v = {
  popover: b
}, N = ({ children: e, p: r, pb: t, pl: p, pr: d, pt: l, ...o }) => {
  const c = i(v.popover, a.surface, n({ p: r, pb: t, pl: p, pr: d, pt: l }));
  return /* @__PURE__ */ s(
    f,
    {
      ...o,
      isKeyboardDismissDisabled: !1,
      isNonModal: !1,
      shouldCloseOnInteractOutside: () => !0,
      className: c,
      "data-component": "Popover",
      children: /* @__PURE__ */ s(m, { className: a.dialog, "aria-label": o["aria-label"], children: e })
    }
  );
};
export {
  N as Popover
};
